// TradeToolbar.tsx
import * as React from "react";
import { Box, Button } from "@chakra-ui/react";
import { FiRefreshCw } from "react-icons/fi";
import { IoFilter } from "react-icons/io5";
// import { PiExport } from "react-icons/pi";
import { FaPlus } from "react-icons/fa";

type Props = {
  onToggleFilters?: () => void;
  onRefresh?: () => void | Promise<void>;
  onExport?: () => void;
  onCreateNewUser?: () => void;
  isLoading?: boolean;
};

const Toolbar: React.FC<Props> = ({
  onToggleFilters = () => {},
  onRefresh = () => {},
  onExport = () => {},
  onCreateNewUser = () => {},
  isLoading = false,
}) => {
  return (
    <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <h3 className="text-xl font-semibold text-navy-700 dark:text-white">
        User Management
      </h3>
      <div className="flex flex-wrap items-center justify-start gap-2 sm:justify-end">
        <Button
          variant="outline"
          onClick={onCreateNewUser}
          className="btn-secondary-green h-9 rounded-md border px-3 text-sm font-semibold tracking-tight shadow-sm"
          leftIcon={<FaPlus size={16} />}
        >
          Create New User
        </Button>
        <Button
          variant="outline"
          onClick={onToggleFilters}
          className="h-9 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
          leftIcon={<IoFilter size={16} />}
        >
          Filters
        </Button>
        <Button
          variant="outline"
          onClick={onRefresh}
          isDisabled={isLoading}
          className="h-9 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
          leftIcon={<FiRefreshCw size={16} />}
        >
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default Toolbar;
